import { LOCIZE_NS, type Languages, languages } from '@avanta/shared/constants/common';
import { cn } from '@avanta/shared/utils/cn';
import { useTranslation } from 'react-i18next';

interface PsychologistLanguagesProps {
  spokenLanguages: Languages[];
  className?: string;
}

export const PsychologistLanguages = ({
  spokenLanguages,
  className,
}: PsychologistLanguagesProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.COMMON);
  return (
    <div className={cn('flex gap-2 flex-wrap', className)}>
      {spokenLanguages.map(language => (
        <div key={language} className="flex items-center gap-2">
          <img
            src={languages[language].image}
            alt={t(languages[language].label)}
            className="size-3"
          />
          <span className="text-xs font-medium">{languages[language].shortLabel}</span>
        </div>
      ))}
    </div>
  );
};
